// 应付单据
<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <payable-component :columnsSource="item.columnsSource" :formSource="item.formSource" :formBtns="item.formBtns"
            :resultCode="item.resultCode" formType="payable"></payable-component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import payableComponent from "./list.vue";
export default {
  components: {
    payableComponent
  },
  data() {
    return {
      tabData: [
        {
          name: "查验已通过",
          resultCode: 1,
          key: "uncommitted",
          formBtns: ["revokeBtn", "importBtn", "addContract", "delContract", "addvoucher", 'exportBtn'],
          columnsSource: [
            "查验编号",
            "卖方名称",
            "发票类型",
            "发票代码",
            "发票号码",
            "开票日期",
            "含税金额(元)",
            // "应付金额(元)",
            "可开立余额(元)",
            "查验方式",
            "合同编号",
            "相关凭证",
            // "操作履约"
          ],
          formSource: [
            "sellrOrgCode",
            "cyCode",
            "invoiceType",
            "invoiceCode",
            "invoiceNumber",
            "contractNo",
            "checkType",
            "billTime",
            "voucherCode"
          ]
        },
        {
          name: "未查验",
          resultCode: 3,
          formBtns: ["deletBtn", "applyUserBtn"],
          key: "unSubmitted",
          columnsSource: [
            "卖方名称",
            "发票类型",
            "发票代码",
            "含税金额(元)",
            "可开立余额(元)",
            "起始日期",
            "操作单据"
          ],
          formSource: [
            "sellrOrgCode",
            "cyCode",
            "invoiceType",
            "invoiceNumber",
            "billTime"
          ]
        },
        {
          name: "查验中",
          resultCode: 0,
          key: "submitted",
          columnsSource: [
            "查验编号",
            "卖方名称",
            "发票类型",
            "发票代码",
            "含税金额(元)",
            "起始日期",
            "查验方式"
          ],
          formSource: [
            "sellrOrgCode",
            "cyCode",
            "invoiceType",
            "invoiceNumber",
            "billTime",
            "checkType"
          ]
        },
        {
          name: "查验不通过",
          resultCode: 2,
          key: "audited",
          formBtns: ["deletBtn", "applyBtn", "applyUserBtn"],
          columnsSource: [
            "查验编号",
            "卖方名称",
            "发票类型",
            "发票代码",
            "含税金额(元)",
            "起始日期",
            "查验方式",
            "操作单据"
          ],
          formSource: [
            "sellrOrgCode",
            "cyCode",
            "invoiceType",
            "invoiceNumber",
            "billTime",
            "checkType"
          ]
        }
      ],
      tabCur: "uncommitted"
    };
  },
  created() {
    this.tabCur = this.$route.query.tabCur || "uncommitted";
  },
  mounted() { },
  methods: {},
  activated() { }
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/payable/index.vue